import React, { useState, useEffect } from 'react';
import UserClasses from '../users/Users.module.css';
import ProductClasses from '../products/Products.module.css';
import { CiSquarePlus } from 'react-icons/ci';
import { FaRegEdit, FaBoxOpen } from 'react-icons/fa'; // Import an icon for no records found
import Layout from 'Components/Layout';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import { SkeletonTheme } from 'react-loading-skeleton';
import UsersSkeleton from '../users/UsersSkeleton';
import { basketTableHeads } from '../constants/Constants';
import { Button, TablePagination, Dialog, DialogTitle, DialogContent, DialogActions, List, ListItem, ListItemText, Select, MenuItem } from '@mui/material';
import CategoryClasses from '../categories/AddCategory.module.css';
import { Services } from 'Services';
import OrderClasses from '../orders/Orders.module.css';
import User from "../../../Assets/user.svg";
import basketPlaceholder from '../../../Assets/fruits-and-vegetables-1.png'; // Import placeholder image
import { Success } from 'Util/Toast';
import { FaSortDown, FaSortUp } from 'react-icons/fa6';
import { AiFillDelete } from 'react-icons/ai';
import { RxCrossCircled } from 'react-icons/rx';

const Basket = () => {
    const [baskets, setBaskets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(() => {
        const savedPage = localStorage.getItem('currentBasketPage');
        return savedPage ? parseInt(savedPage, 10) : 0;
    });
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const [sortOrder, setSortOrder] = useState('asc'); // Added for sorting
    const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deletingBasketId, setDeletingBasketId] = useState(null);
    const [filteredBaskets, setFilteredBaskets] = useState([]);




    const navigate = useNavigate();

    // FIXME:Fetching data from the API

    useEffect(() => {
        const fetchBaskets = async () => {
            try {
                const token = { Authorization: `token ${localStorage.getItem('Token')}` };
                const response = await Services.getBaskets(token);
                setBaskets(response.data);
                setFilteredBaskets(response.baskets || []); // Ensure it's always an array
                setTotalCount(response.data.length);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching baskets:', error);
                setLoading(false);
            }
        };

        fetchBaskets();
    }, []);

    useEffect(() => {
        localStorage.setItem('currentBasketPage', page);
    }, [page]);

    // TODO: navigate to add basket page

    const handleAddBasketClick = () => {
        navigate('/add-basket');
    };

    const handleDeleteClick = async (event, basketId) => {
        event.stopPropagation();
        setDeletingBasketId(basketId);
        setDeleteModalOpen(true);
    };

    // TODO: navigate to edit basket page

    const handleEditBasketClick = (basketId) => {
        localStorage.setItem('currentBasketPage', page);
        navigate(`/edit-basket/${basketId}`);
    };

    const handleConfirmDelete = async () => {
        if (deletingBasketId) {
            try {
                const token = { Authorization: `token ${localStorage.getItem('Token')}` };
                const response = await Services.deleteBasket(deletingBasketId, token);

                if (response.Status === 1) {
                    // Remove the deleted basket from the state
                    setBaskets(baskets.filter(basket => basket.basketId !== deletingBasketId));

                    // Check if filteredBaskets is an array before using filter
                    if (Array.isArray(filteredBaskets)) {
                        setFilteredBaskets(filteredBaskets.filter(basket => basket.basketId !== deletingBasketId));
                    }

                    setTotalCount(totalCount - 1);

                    // Display the success message
                    Success(response.Message);

                    // Close the delete modal
                    setDeleteModalOpen(false);
                } else {
                    console.error('Error deleting product:', response.Message);
                }
            } catch (error) {
                console.error('Error deleting product:', error);
            }
        }
    };



    const handleDeleteModalClose = () => {
        setDeleteModalOpen(false);
        setDeletingBasketId(null);
    };

    // FIXME: handle change page for pagination

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // FIXME: handle change rows per page for pagination

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    // TODO: Calculate the indices for the current page
    const indexOfLastItem = (page + 1) * rowsPerPage;
    const indexOfFirstItem = indexOfLastItem - rowsPerPage;

    // TODO: Slice baskets data to get items for the current page
    const currentBaskets = baskets.slice(indexOfFirstItem, indexOfLastItem);

    const handleBasketStatusChange = async (basketId, status) => {
        try {
            const token = { Authorization: `token ${localStorage.getItem('Token')}` };
            const response = await Services.changeBasketStatus(basketId, status, token);
            Success(response.Message)
            // TODO: Refresh the baskets data after status change
            const responseData = await Services.getBaskets(token);
            setBaskets(responseData.data);
        } catch (error) {
            console.error('Error changing basket status:', error);
        }
    };

    // Sorting logic
    const handleSortByBasketName = () => {
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc';
        const sortedBaskets = [...baskets].sort((a, b) => {
            const nameA = a.basketName.toLowerCase();
            const nameB = b.basketName.toLowerCase();

            if (nameA < nameB) return newSortOrder === 'asc' ? -1 : 1;
            if (nameA > nameB) return newSortOrder === 'asc' ? 1 : -1;
            return 0;
        });

        setSortOrder(newSortOrder); // Update the sort order first
        setBaskets(sortedBaskets); // Then update the baskets with the sorted data
    };


    return (
        <Layout Active={'Basket'}>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Basket</title>
            </Helmet>
            <div className={UserClasses['main-first-container']}>
                <div className={ProductClasses['main-add-btn']}>
                    <Button data-aos="zoom-in" variant="contained" color="primary" onClick={handleAddBasketClick}>
                        Add Basket <CiSquarePlus className="CiSquarePlus" />
                    </Button>
                </div>
                <div className={UserClasses['main-data-tab']}>
                    <div className={UserClasses['users-main']}>
                        <h2 className={OrderClasses['header-form']}>
                            Basket Details <span className={UserClasses['head-count-main']}>({totalCount})</span>
                        </h2>
                        <div>
                            <SkeletonTheme color='#ddd' highlightColor='#eee'>
                                {loading ? (
                                    <UsersSkeleton TableHeader={basketTableHeads} />
                                ) : (
                                    <div style={{ overflowY: 'hidden' }}>
                                        {baskets.length > 0 ? (
                                            <>
                                                <table className={ProductClasses['category-table']}>
                                                    <thead>
                                                        <tr className={UserClasses['main-table-heads']}>
                                                            <th style={{ display: 'flex', justifyContent: 'center' }} className={ProductClasses['products-table-head']}>
                                                                <Button
                                                                    onClick={handleSortByBasketName}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                    title={`Sort by Basket Name (${sortOrder === 'asc' ? 'Ascending' : 'Descending'})`}
                                                                >
                                                                    Basket Name
                                                                    {sortOrder === 'asc' ? (
                                                                        <FaSortUp style={{ marginLeft: '5px' }} />
                                                                    ) : (
                                                                        <FaSortDown style={{ marginLeft: '5px' }} />
                                                                    )}
                                                                </Button>
                                                            </th>
                                                            {basketTableHeads.slice(1).map((head, index) => (
                                                                <th key={index} className={ProductClasses['products-table-head']}>{head}</th>
                                                            ))}
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentBaskets.map((basket) => (
                                                            <tr key={basket.basketId} data-aos="fade-up"
                                                                data-aos-anchor-placement="top-bottom">
                                                                <td className={CategoryClasses["table-cell"]}>{basket.basketName}</td>
                                                                <td className={UserClasses["view-users-main"]}>
                                                                    <Button variant="outlined" onClick={() => {
                                                                        setSelectedUser(basket.users);
                                                                        setDialogOpen(true);
                                                                    }}>
                                                                        View Users
                                                                    </Button>
                                                                </td>
                                                                <td>{basket.noOfProducts}</td>
                                                                <td>₹{basket.basketPrice}</td>
                                                                <td>
                                                                    <Select
                                                                        className={UserClasses['basket-status-main']}
                                                                        value={basket.basketStatus === 1 ? 'Active' : 'Inactive'}
                                                                        onChange={(event) => handleBasketStatusChange(basket.basketId, event.target.value === 'Active' ? 1 : 0)}
                                                                        renderValue={(selected) => (
                                                                            <div>
                                                                                {selected === 'Active' && <span className={`${CategoryClasses['status-dot']} ${CategoryClasses['active']}`}></span>}
                                                                                {selected === 'Inactive' && <span className={`${CategoryClasses['status-dot']} ${CategoryClasses['inactive']}`}></span>}
                                                                                {selected}
                                                                            </div>
                                                                        )}
                                                                    >
                                                                        <MenuItem value="Active">Active</MenuItem>
                                                                        <MenuItem value="Inactive">Inactive</MenuItem>
                                                                    </Select>

                                                                </td>
                                                                <td>
                                                                    <button onClick={() => handleEditBasketClick(basket.basketId)} className={`${CategoryClasses['edit-button']} ${CategoryClasses['button']}`}>
                                                                        <FaRegEdit />
                                                                    </button>
                                                                    <button
                                                                        className={CategoryClasses['delete-button']}
                                                                        onClick={(event) => {
                                                                            event.stopPropagation();  // Prevent row click when deleting
                                                                            handleDeleteClick(event, basket.basketId);
                                                                        }}
                                                                    >
                                                                        <AiFillDelete />
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>

                                                {/* TODO: Pagination */}
                                                <div className={UserClasses['table-pagination']}>
                                                    <div className={UserClasses['current-page']}>
                                                        <p>Current Page: {page + 1}</p>
                                                    </div>
                                                    <TablePagination
                                                        component="div"
                                                        count={baskets.length}
                                                        page={page}
                                                        onPageChange={handleChangePage}
                                                        rowsPerPage={rowsPerPage}
                                                        onRowsPerPageChange={handleChangeRowsPerPage}
                                                    />
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                                <img height={100} src={basketPlaceholder} alt="No Baskets" data-aos="zoom-in" />
                                                <p style={{ marginTop: '10px', fontSize: '18px', color: 'gray' }}>No Baskets Found</p>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </SkeletonTheme>
                        </div>
                    </div>
                </div>
            </div>

            {/* TODO: Simple Dialog */}
            <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '400px', // Adjust width as needed
                    },
                    '& .MuiDialogTitle-root': {
                        backgroundColor: 'black', // Customize title background color
                        padding: '10px 20px', // Adjust padding as needed
                        textAlign: 'center', // Center-align the title
                        color: 'white',
                    },
                    '& .MuiDialogContent-root': {
                        padding: '20px', // Adjust padding as needed
                    },
                    '& .MuiDialogActions-root': {
                        padding: '10px 20px', // Adjust padding as needed
                        justifyContent: 'flex-end', // Align actions to the right
                    },
                }}
            >
                <DialogTitle>Basket Assigned Users</DialogTitle>
                <DialogContent>
                    {selectedUser && selectedUser.length > 0 ? (
                        <List>
                            {selectedUser.map((user, index) => (
                                <ListItem button key={index}>
                                    <img src={User} alt={user.name} style={{ width: '30px', height: '30px', marginRight: '10px', borderRadius: '50%' }} />
                                    <ListItemText primary={user.name} />
                                </ListItem>
                            ))}
                        </List>
                    ) : (
                        <p>No Users Found</p>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button style={{ backgroundColor: 'black', color: 'white' }} onClick={() => setDialogOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>
            {isDeleteModalOpen && (
                <div className={CategoryClasses['edit-modal-overlay']}>
                    <div className={CategoryClasses['edit-modal']} data-aos="zoom-in-down">
                        <div className={CategoryClasses['modal-content']}>
                            <h1><RxCrossCircled /></h1>
                            <h2>Are you sure?</h2>
                            <p>Do you really want to delete these records? This process cannot be undone.</p>
                        </div>
                        <div className={CategoryClasses['modal-last-div']}>
                            <button onClick={handleDeleteModalClose} className={CategoryClasses['modal-close-button']}>Close</button>
                            <button onClick={handleConfirmDelete} className={CategoryClasses['modal-save-button']}>Delete</button>
                        </div>
                    </div>
                </div>
            )}
        </Layout>
    );
};

export default Basket;
